import { useEffect } from "react";
import { Client } from "../components/client/types";

interface ClientPageAIModalBridgeOptions {
  setClientForModal: (client: Client | null) => void;
  setIsClientModalOpen: (open: boolean) => void;
  navigate: (route: string) => void;
}

/** Listens for AI-triggered "open ClientModal" requests and exposes window hooks the AI agent calls directly. */
export function useClientPageAIModalBridge({
  setClientForModal,
  setIsClientModalOpen,
  navigate,
}: ClientPageAIModalBridgeOptions) {
  useEffect(() => {
    const handleAIModalRequest = (event: any) => {
      const data = event.detail || event;
      const modalName = data.modalName || data.targetModal;
      const modalParams = data.modalParams || {};

      if (modalName === "ClientModal") {
        if (modalParams.mode === "edit" && modalParams.clientData) {
          setClientForModal(modalParams.clientData);
          setIsClientModalOpen(true);
        } else {
          setClientForModal(null);
          setIsClientModalOpen(true);
        }
      }
    };

    // Listen for both custom events and direct function calls
    window.addEventListener("ai-open-modal", handleAIModalRequest);

    // Also expose a global function for direct calls
    (window as any).openModalFromAI = handleAIModalRequest;

    // Expose navigation function for AI
    (window as any).navigateFromAI = (route: string) => {
      navigate(route);
    };

    return () => {
      window.removeEventListener("ai-open-modal", handleAIModalRequest);
      delete (window as any).openModalFromAI;
      delete (window as any).navigateFromAI;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
}
